import React, { useEffect, useMemo, useState } from "react";
import Logo from "../../assets/images/ic-password.png"
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useResendOtpSmsMutation } from "../../services/chatService";
import { useGroupChatContext } from "../../context/groupchatContext";
import { Loader } from "../../components/loader";
import { NumericField } from "../../components/reactHookFormFields/numericField";

const AuthVerification = ({ triggerLoginCall = () => { } }) => {

  const groupChatContext = useGroupChatContext();
  const { authData } = useMemo(() => ({
    authData: groupChatContext.authData,
  }));

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({});

  const [resendOtpSms, { isLoading: isSendingOtp }] = useResendOtpSmsMutation();
  const isNurse = !authData?.is_provider;
  const auth = JSON.parse(localStorage.getItem("auth"));
  const resendSMSCode = async () => {
    try {
      if (!authData?.two_factor_auth_id) {
        toast.error("Two factor authentication id not found");
        return;
      }

      const payload = {
        two_factor_auth_id: authData?.two_factor_auth_id || auth?.two_factor_auth_id || ''
      }

      if (isNurse) {
        payload["user_type"] = "nurse"
      }

      const res = await resendOtpSms(payload);

      const { code, msg } = res?.data || {};

      if (code === 0) {
        toast.success(msg || "Code resent successfully")
      } else if (code !== -1) {
        toast.error(msg || "Failed to resend code")
      }
    } catch (error) {
      toast.error("Failed while resending code")
    }
  }



  const handleCodeSubmit = async (data) => {

    const payload = {
      two_factor_auth_id: authData.two_factor_auth_id || auth?.two_factor_auth_id || '',
      two_factor_auth_code: data?.code,
    };
    triggerLoginCall(payload, '2fa_form')
  };

  return (
    <>
      {isSendingOtp ?
        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none before:absolute before:flex before:bg-black/25 before:w-full before:h-full z-[999]">
          <Loader />
        </div>
        : null
      }

      <div className="sm:mx-auto sm:w-full sm:max-w-[860px] shadow ">
        <div className="!bg-white px-4 py-8 shadow sm:rounded-lg sm:px-12 curve-bg">
          <div className="sm:mx-auto sm:w-full flex items-center flex-col sm:max-w-[690px]">
            <img src={Logo} alt="" className="w-[100px]" />
            <h2 className="mt-4  text-center text-2xl font-bold leading-9 tracking-tight text-[#78797d]">
              {authData.two_factor_auth_type == "sms" ? "Verification Code" : "Authentication Code"}
            </h2>
            <h2 className="text-center text-lg  font-normal leading-9 tracking-tight">
              {authData.two_factor_auth_type == "sms" ? "Please type the verification code sent to your mobile number." : "Please enter 6-digit code from your two factor Authentication app."}
            </h2>
          </div>

          <form className="space-y-4 mt-8" method="POST" autoComplete="off">
            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
              <div className="mb-2 text-start">
                <NumericField
                  title="Enter code"
                  name="code"
                  control={control}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 6);
                  }}
                  rules={{
                    required: {
                      value: true,
                      message: "Please enter code",
                    },
                    pattern: {
                      value: /^\d{6}$/,
                      message: "Code must be exactly 6 digits",
                    },
                  }}
                  errors={errors}
                />
              </div>
              {authData.two_factor_auth_type == "sms" &&
                <p>Didn’t receive the code? <span onClick={resendSMSCode} className='text-red-500 font-bold cursor-pointer hover:text-red-700'>Resend Code</span></p>
              }
            </div>
            <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-sm">
              <button
                onClick={handleSubmit(handleCodeSubmit)}
                // disabled={isLoading}
                className="flex w-full justify-center rounded-md bg-[#471C57] px-3 py-2 mt-3 font-semibold leading-6 text-white shadow-sm hover:bg-[#471C57] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#471C57]">
                Proceed
              </button>
            </div>
            <p className='text-gray-400 text-center'>Copyright &copy; 2024, All rights reserved.</p>
          </form>
        </div>
      </div>
    </>
  );
};

export default AuthVerification;
